document.addEventListener('DOMContentLoaded', () => {
  const personalizationRadios = document.querySelectorAll('input[name="Personalization"]');
  const textField = document.getElementById('personalization-field');
  const customInput = document.getElementById('custom-text');

  personalizationRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      // Check for either "Add Personalization" or "Personalization"
      if ((radio.value === 'Add Personalization' || radio.value === 'Personalization') && radio.checked) {
        textField.style.display = 'block';
        customInput.setAttribute('required', 'true'); // Make the field required
      } else if (radio.value === 'No Personalization' && radio.checked) {
        textField.style.display = 'none';
        customInput.removeAttribute('required'); // Remove required attribute
        customInput.value = ''; // Clear previous input
      }
    });
  });
});
